import notifyingAction from "domainActions/notifyingAction";
import { triggerTeamSync as triggerTeamSyncFn } from "../hooks/useTeamSync";
const triggerTeamSync = notifyingAction({
  action: triggerTeamSyncFn,
  error: (error, _backendId, backendTitle) => ({
    message: `Synchronizing teams for authentication service "${backendTitle}" failed with status: ${error}`
  })
});
export default {
  triggerTeamSync
};
